module.exports = __webpack_public_path__ + "img/successIcon.26a94a84.png";